import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  Loan,
  LoanProtection,
  Period,
} from '../../../../share/type/result_type';
import { ResultpageService } from '../../../../share/service/resultpage.service';
import { ResultpagesharedService } from '../../../../share/service/resultpageshared.service';
import {
  Subscription,
  isEmpty,
  combineLatest,
  share,
  BehaviorSubject,
} from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-loan',
  templateUrl: './loan.component.html',
  styleUrls: ['./loan.component.scss'],
})
export class LoanComponent implements OnInit {
  @Input() loanRequestError!: boolean;
  @Input() loanRequestErrorMessage!: string;

  @Output() loanOutput = new EventEmitter<string>();

  public loanData!: Loan;
  public period!: Period;
  public loanProtection!: LoanProtection;
  public btnLoader: boolean = false;

  private loanDataSubscription: Subscription;
  private offersDataSubscription: Subscription;
  private previousOffersLength = 0;

  public periodValue!: any;
  public openOverlay: boolean = false;
  private token!: string;

  public protectionData = [
    {
      name: 'Kein Kreditschutz',
      value: 'RSV_NONE',
      rsvLevel: 0,
    },
    {
      name: 'Basis: Tod',
      value: 'RSV_TOD',
      rsvLevel: 1,
    },
    {
      name: 'Standard: Tod & Arbeitsunfähigkeit',
      value: 'RSV_BU',
      rsvLevel: 2,
    },
    {
      name: 'Komplett: Tod, Arbeitsunfähigkeit & Arbeitslosigkeit',
      value: 'RSV_ALO',
      rsvLevel: 3,
    },
  ];

  constructor(
    private resultpageService: ResultpageService,
    private sharedResultService: ResultpagesharedService
  ) {}

  ngOnInit(): void {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    this.token = urlParams.get('t') ?? '';

    // Initialize previous offers length
    this.previousOffersLength =
      this.sharedResultService.dataOffers?.length || 0;

    this.getLoanData();
    this.watchForOffers();
  }

  ngOnDestroy() {
    this.loanDataSubscription.unsubscribe();
    if (this.offersDataSubscription) {
      this.offersDataSubscription.unsubscribe();
    }
  }

  getLoanData(): void {
    this.loanDataSubscription =
      this.resultpageService.loanStateDataObserv$.subscribe((data) => {
        if (data !== 1) {
          // Create a copy of the data to avoid modifying the shared object
          this.loanData = { ...data };
          this.formatLoanDataPeriod();
          this.loanProtection = this.protectionData.find(
            (obj) => obj.value == this.loanData.creditProtection
          );
        } else {
          this.loanData = {
            creditProtection: 'RSV_NONE',
            duration: '12',
            durationOptions: [{ month: 12 }],
            value: 0,
          };
          this.loanProtection = this.protectionData.find(
            (obj) => obj.value == this.loanData.creditProtection
          );
          this.formatLoanDataPeriod();
        }
      });
  }

  private watchForOffers(): void {
    this.offersDataSubscription =
      this.resultpageService.offersDataObserv$.subscribe((offersData) => {
        if (offersData === 1) return;

        const currentLength = offersData?.length || 0;

        if (this.btnLoader) {
          // Reset loader on state transitions
          if (
            (this.previousOffersLength > 0 && currentLength === 0) ||
            (this.previousOffersLength === 0 && currentLength >= 1)
          ) {
            this.btnLoader = false;
          }
        }

        this.previousOffersLength = currentLength;
      });
  }

  openFilterForm(): void {
    this.openOverlay = !this.openOverlay;
    const loan = document.getElementById('loan') as HTMLElement;
    loan.classList.toggle('openForm');
  }

  formatLoanDataPeriod(): void {
    this.period = this.getNewArr(this.loanData.durationOptions);
    this.periodValue = this.loanData.duration + ' Monate';
  }

  getNewArr(arr: any) {
    return arr
      ? arr.map((obj: Period) => {
          return {
            name: obj.month + ' Monate',
            value: obj.month,
          };
        })
      : null;
  }

  addLoan(value: any, key: string): void {
    if (key === 'duration') {
      this.loanData[key] = value.value;
      this.formatLoanDataPeriod();
    } else if (key === 'creditProtection') {
      this.loanData[key] = value.value;
      this.loanProtection = value; // Keep the full object for UI display
    } else {
      this.loanData[key] = value;
    }
  }

  sendLoan(): void {
    this.btnLoader = true;

    let obj: any = {
      value: this.loanData.value,
      duration: this.loanData.duration,
      creditProtection: this.loanData.creditProtection,
    };

    //---updating loan local data---
    this.resultpageService.updatedLoanDataPost(obj);
    //---updating loan local data---

    this.resultpageService.updateStateLoanData(this.loanData);

    //---create pos request in parent component---
    this.loanOutput.emit();
    //---create pos request in parent component---
    this.openFilterForm();
  }

  get isLoading(): boolean {
    return (this.sharedResultService.dataOffers?.length || 0) === 0 && this.sharedResultService.loading;
  }

  get showSpinner(): boolean {
    return this.btnLoader && !this.isLoading;
  }
}
